'use client';

import { Toaster } from 'sonner';

export default function Toast() {
  return (
    <Toaster
      position="bottom-right"
      toastOptions={{
        style: {
          background: 'hsl(222, 35%, 12%)',
          border: '1px solid hsl(222, 25%, 22%)',
          color: 'hsl(210, 40%, 96%)',
          fontFamily: 'DM Sans, sans-serif',
          fontSize: '14px',
        },
      }}
    />
  );
}